import React, { useEffect, useState } from "react";
import { useStores } from "../../../use-stores";
import {
  Box,
  Container,
  Paper,
  Typography,
  CircularProgress,
  useTheme,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PageTitle from "../../components/common/pages/PageTitle";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import { useParams } from "react-router-dom";
import { useNotification } from "../../../utils/NotificationsContext";
import { EmployeeRoles } from "../../../models/Employees/EmployeeRoles";
import InventorySwagpackVariantTable from "../../components/Inventory/InventorySwagpackVariantTable";

const InventorySwagpackVariant: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { inventoryStore, userStore } = useStores();
  const [isLoading, setIsLoading] = useState(false);
  const { showError } = useNotification();
  const { id } = useParams();
  const packId = Number(id);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        await inventoryStore.getSwagpackVariants(packId);
      } catch (error) {
        showError("Error", "Failed to fetch swagpack Variants data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [packId]);

  if (!userStore.hasPermission(EmployeeRoles.VIEW_INVENTORY)) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10rem"
        textAlign="center"
      >
        <Typography variant="h6" fontWeight="500" color="text.secondary">
          You don't have permission to view this section.
        </Typography>
      </Box>
    );
  }

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="200px"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container sx={{ paddingTop: 2 }} maxWidth="xl">
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer",
          color: theme.palette.customColors.greyTextColor,
          "&:hover": {
            color: theme.palette.customColors.greyTextColor,
          },
          "&:active": {
            color: theme.palette.customColors.greyTextColor,
          },
          mb: 2,
          maxWidth: "60px",
        }}
        onClick={() => navigate(-1)}
      >
        <ArrowBackIcon sx={{ fontSize: "16px" }} />
        <span style={{ fontSize: "14px", fontWeight: "600" }}>Back</span>
      </Box>
      <Paper sx={{ padding: 5, paddingBottom: 3, paddingTop: 3 }}>
        <PageTitle title="Inventory Swagpacks Variants" />
        <Box>
          <InventorySwagpackVariantTable
            maxHeight={window.innerHeight}
            variants={inventoryStore.variant || []}
          />
        </Box>
      </Paper>
    </Container>
  );
};

export default observer(InventorySwagpackVariant);
